// extracted by mini-css-extract-plugin
export var card = "_js-5";
export var cardSelected = "_js-4";
export var image = "_js-3";
export var modal = "_js-0";
export var modalContent = "_js-1";
export var table = "_js-2";